
heraldicon.frontend.main.init();